import layout from './layout'
import header from './header'

const zhCN = { layouts: layout.zhCN, layoutsHeader: header.zhCN }
const enUS = { layouts: layout.enUS, layoutsHeader: header.enUS }

export default { zhCN, enUS }